import React, { useEffect } from "react";

import "./footer.css";
import LogoIcon from "../assets/icons/logoIcon";
import InstagramIcon from "../assets/icons/socialMedia/instagramIcon";
import WebsiteIcon from "../assets/icons/socialMedia/websiteIcon";
import { useSafeNavigate } from "../components/unloadBlocker";
import { useNavigate } from "react-router-dom";
import TxoriaLogo from "../assets/icons/logo";

export default function Footer() {

    const [footerHeight, setFooterHeight] = React.useState(0);

    function calcFooterHeight() {
        const footer = document.querySelector("footer");
        if (footer) {
            const height = footer.getBoundingClientRect().height;
            document.body.style.setProperty("--footer-height", `${height}px`);
            setFooterHeight(height);
        }
    }

    function calcFooterInView() {
        const footer = document.querySelector("footer");
        if (footer) {
            var currentScrollPos = document.documentElement.scrollTop || document.body.scrollTop;
            var scrollMaxY = (document.documentElement.scrollHeight - document.documentElement.clientHeight)
            const rect = footer.getBoundingClientRect();
            var footerInView = currentScrollPos - (scrollMaxY - footerHeight) + 60;
            if(footerInView < 0) {
                footerInView = 0;
            }
            if(footerInView > currentScrollPos) {
                footerInView = currentScrollPos;
            }
            document.body.style.setProperty("--footer-in-view", `${footerInView}px`);
        }
    }

    useEffect(() => {
        calcFooterHeight();
        document.body.style.setProperty("--footer-in-view", `0px`);
        window.addEventListener("resize", calcFooterHeight);
        window.addEventListener("scroll", calcFooterInView);
        return () => {
            window.removeEventListener("resize", calcFooterHeight);
            window.removeEventListener("scroll", calcFooterInView);
        };
    })

    const navigate = useSafeNavigate(useNavigate());

    return <footer>
        <div className="logo">
            <TxoriaLogo/>
        </div>
        <div className="vueste">
            <h3>Txoria.org</h3>
            <a onClick={() => {
                window.open("https://vueste.de", "_blank");
            }}>Powered by vueste</a>
            <div className="social-media">
                <div className="instagram">
                    <InstagramIcon/>
                </div>
                <div className="website">
                    <WebsiteIcon/>
                </div>
            </div>
        </div>
        <div className="link-list support">
            <h3>Support</h3>
            <a href="mailto:contact@txoria.org">Contact</a>
            <a href="mailto:feedback@txoria.org">Feedback</a>
            <a onClick={() => {navigate("/faq");}}>FAQ</a>
        </div>
        <div className="link-list legal">
            <h3>Legal</h3>
            <a href="/imprint">Imprint</a>
            <a href="/terms">Terms of use</a>
            <a href="/privacy-policy">Privacy Policy</a>
        </div>
    </footer>;
}